<template>
  <Flex
    direction="column"
    :gap="0.5"
  >
    <BaseTask
      v-if="!isTreatwellUser"
      :heading="
        $t(
          `admin.treatwell.main.getting_paid.${
            treatwellStatus.contractSigned
              ? 'your_contract'
              : 'sign_contract'
          }`
        )
      "
      text=""
      :state="
        treatwellStatus.contractSigned ? 'completed' : 'required'
      "
      :buttonIcon="
        treatwellStatus.contractSigned ? 'download' : 'brush'
      "
      @click="openContract"
      @buttonClick="openContract"
      v-test="'contract-todo-item'"
      v-intercom="'mp-dashboard-task-contract'"
    />
    <BaseTask
      :heading="
        company.address
          ? $t(
              'admin.treatwell.main.getting_paid.company_info_provided'
            )
          : $t(
              'admin.treatwell.main.getting_paid.provide_company_info'
            )
      "
      text=""
      :state="
        providedCompanyInfo
          ? 'completed'
          : treatwellStatus.contractSigned
          ? 'required'
          : 'blocked'
      "
      :buttonIcon="
        !treatwellStatus.contractSigned
          ? undefined
          : providedCompanyInfo
          ? 'eye'
          : 'edit'
      "
      @click="router.push({ name: 'treatwell-salon-info' })"
      @buttonClick="router.push({ name: 'treatwell-salon-info' })"
      v-test="'company-info-todo-item'"
      v-intercom="'mp-dashboard-task-company-info'"
    />
    <BaseTask
      :heading="
        $t(
          `admin.treatwell.main.getting_paid.${
            treatwellStatus.bankDetailsProvided
              ? 'bank_details_provided'
              : 'provide_bank_details'
          }`
        )
      "
      text=""
      :state="
        treatwellStatus.bankDetailsProvided
          ? 'completed'
          : treatwellStatus.contractSigned && providedCompanyInfo
          ? 'required'
          : 'blocked'
      "
      :buttonIcon="
        !treatwellStatus.contractSigned || !providedCompanyInfo
          ? undefined
          : treatwellStatus.bankDetailsProvided
          ? 'eye'
          : 'edit'
      "
      @click="openIban"
      @buttonClick="openIban"
      v-test="'iban-todo-item'"
      v-intercom="'mp-dashboard-task-iban'"
    />
    <BaseTask
      v-if="isTreatwellUser || unleash.isEnabled('TW_KYC_FLOW')"
      :heading="
        $t(
          `admin.treatwell.main.getting_paid.${
            treatwellStatus.kycStatus?.kycCompleted
              ? 'kyc_completed'
              : 'kyc_connect'
          }`
        )
      "
      :text="
        treatwellStatus.bankDetailsProvided &&
        !treatwellStatus.kycStatus?.onboardingUrl
          ? $t('admin.treatwell.main.getting_paid.kyc_preparing')
          : treatwellVenue &&
            !treatwellStatus.kycStatus?.kycCompleted
          ? $t('admin.treatwell.main.getting_paid.kyc_explanation')
          : ''
      "
      :state="
        treatwellStatus.kycStatus?.kycCompleted
          ? 'completed'
          : !treatwellStatus.kycStatus?.onboardingUrl
          ? 'blocked'
          : 'attention'
      "
      :buttonIcon="
        !treatwellStatus.kycStatus?.kycCompleted &&
        treatwellStatus.kycStatus?.onboardingUrl
          ? 'external_link'
          : undefined
      "
      @click="emit('kyc')"
      @buttonClick="emit('kyc')"
      v-test="'tw-kyc-todo-item'"
      v-intercom="'tw-kyc-todo-item'"
    />
    <BaseTask
      v-if="isTrial"
      :heading="$t('subscription.heading', brandName())"
      text=""
      :state="
        treatwellStatus.kycStatus?.kycCompleted
          ? 'required'
          : 'blocked'
      "
      :buttonIcon="
        treatwellStatus.kycStatus?.kycCompleted
          ? 'external_link'
          : undefined
      "
      @click="emit('subscribe')"
      @buttonClick="emit('subscribe')"
      v-test="'subscribe-todo-item'"
      v-intercom="'mp-dashboard-task-subscribe'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';
import type { TreatwellVenue } from '@/types';
import unleash from '@/unleash';

// The tasks a salon has to finish before it can go live: contract to verification
const props = defineProps<{
  treatwellVenue: Partial<TreatwellVenue> | null;
  contractDownloadUrl?: string | null;
}>();

const emit = defineEmits<{
  kyc: [];
  subscribe: [];
}>();

const router = useRouter();
const { treatwellStatus, providedCompanyInfo } = storeToRefs(
  useTreatwellStore(),
);
const { company } = storeToRefs(useCompanyStore());
const { isTreatwellUser, isTrial } = useCompanyStore();

const openContract = () => {
  if (!treatwellStatus.value.contractSigned) {
    router.push({ name: 'treatwell-sign-contract' });
  } else if (props.contractDownloadUrl) {
    window.open(props.contractDownloadUrl, '_blank');
  }
};

const openIban = () => {
  if (treatwellStatus.value.contractSigned) {
    router.push({ name: 'treatwell-provide-iban' });
  }
};
</script>
